module.exports = __webpack_public_path__ + "static/media/editor-inspector-view.028b3787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/editor-inspector-view.jpg
// module id = 1005
// module chunks = 4